import React from 'react'
import { Typography, Divider } from 'antd'

const { Text } = Typography

const msToHMS = (ms) => {
    const h = Math.floor(ms / 3600000)
    const m = Math.floor((ms % 3600000) / 60000)
    const s = Math.floor((ms % 60000) / 1000)
    return `${h}h ${m}m ${s}s`
}

const ProjectLogPopover = ({ project }) => {
    return (
        <div>
            <div style={{ display: 'flex', alignItems: "center", justifyContent: "space-between" }}>

                <Text style={{ fontSize: 13, fontWeight: 700 }}>{project.projectName}</Text>
                <Text style={{ fontSize: 12, fontWeight: 700 }}>
                    {msToHMS(project.totalProjectDuration)}
                </Text>
            </div>
            <Divider style={{ margin: '6px 0' }} />
            {project.tasks.map((task, index) => (
                <div
                    key={index}
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontSize: 12,
                        marginBottom: 4,
                    }}
                >
                    <span>{task.taskTitle}</span>
                    <span>{msToHMS(task.totalTaskDuration)}</span>
                </div>
            ))}
        </div>
    )
}

export default ProjectLogPopover
